import SurveyExpertContainer from '../../../../components/survey/SurveyExpertContainer';
import { useFocusedMeetingAPI } from '../../../../hooks/meeting';
import styles from './survey.module.css';

const MeetingSurveyExpertPage = () => {
  const meetingContainerAPI = useFocusedMeetingAPI();

  return (
    <div className={styles.container}>
      <SurveyExpertContainer 
        meetingContainerAPI={meetingContainerAPI}
      />
    </div>
  )
};

export default MeetingSurveyExpertPage;
